import { Component, Input } from '@angular/core';

@Component({
    selector: 'cv-wallboards-assign',
    templateUrl: './wallboards-assign.component.html',
    styleUrls: ['./wallboards.component.scss']
})
export class WallboardsAssignComponent {

    @Input() showall: boolean = true;
    @Input() lst: any[];
    @Input() onremove;
    @Input() empgrouptypes;

    constructor() { }

    public filteredList(groupLevel: number) {
        return this.lst.filter(o => o.GroupLevel == groupLevel || groupLevel == 0);
    }

}
